module.exports = __webpack_public_path__ + "media/unlock.a89f9af6.wav";